<marv-item (click)="this.selectMission()">
    <div class="mission_item">
        
        <div class="mission_item_retailer">
            <app-retailer-logo [retailer]="this.getRetailerLogo()"/>

            <div class="mission_item_infos">
                @if(this.mission.store.name){
                    <ion-label class="mission_item_pdv">{{this.mission.store.name}}</ion-label>
                    <ion-note class="mission_item_pdv_address">{{(this.mission.store.administrativeArea ? this.mission.store.administrativeArea+(this.mission.store.zipCode ? this.mission.store.zipCode : '')+' ' : '')}}{{this.mission.store.city}}</ion-note>
                }
                @else{
                    <ion-label class="mission_item_description">{{this.mission.description}}</ion-label>
                }
                <div class="mission_item_op">
                    <marv-tag [color]="this.missionTypeService.getColor(this.mission.operation.typeOfMission)" size="small">{{this.mission.operation.name}}</marv-tag>
                </div>
                
                @if(this.mission.planningEntryType === 'STORECHECK' && this.mission.purposes){
                    <div class="mission_item_purposes">
                        @for(purpose of this.mission.purposes; track $index){
                            <div class="mission_item_purpose" [class.fulfilled]="purpose.fulfilled">{{purpose.name}}</div>
                        }
                    </div>
                }
                
            </div>
        </div>
        
        @if(this.displayDay || this.displayHour){
            <div class="mission_item_day">
                @if(this.displayDay){
                    <div class="mission_item_date">
                        <ion-icon name="calendar-outline"></ion-icon>{{this.mission.day | epochToString }}
                    </div>
                }
                
                @if(this.displayHour){
                    <div class="mission_item_hour">
                        <ion-icon name="time-outline"></ion-icon>
                        @if(this.mission.amStartTime && this.mission.pmEndTime){
                            {{this.mission.amStartTime}} - {{this.mission.pmEndTime}}
                        }
                        @else if(this.mission.amStartTime){
                            {{this.mission.amStartTime}}
                        }
                        @else if(this.mission.pmStartTime){
                            {{this.mission.pmStartTime}}
                        }

                        @if(this.mission.duration){
                            @if(this.mission.amStartTime || this.mission.pmEndTime){
                                -
                            }                        
                            {{this.mission.duration}}
                        }
                         
                    </div>
                }
                
                @if(this.mission.customerSector?.name){
                    <div class="mission_item_sector">
                        <ion-icon name="trail-sign-outline"></ion-icon>
                        {{this.mission.customerSector?.name}}
                    </div>
                }
                
                @if(this.displayProfil){
                    <div class="mission_item_profil">
                        <ion-icon name="person-outline"></ion-icon>
                        @if(this.mission.salesRep?.name){
                            {{this.mission.salesRep?.name}}
                        }
                        @else{
                            <div>
                                {{'PROFIL' | translate }}
                                @if(this.mission.profil){
                                    &nbsp;&laquo; {{this.mission.profil}} &raquo;
                                }                                
                                @if(this.mission.affected){
                                    &nbsp;-&nbsp;<b>{{'AFFECTED' | translate}}</b>
                                }
                            </div>
                        }   
                        
                        @if(this.mission.recoCompliance){
                            <div class="mission_item_reco">{{'RECO' | translate}}</div>
                        }
                        
                    </div>
                }
            </div>
        }
        
        @if(this.displayReport && this.mission.showPresenceCheckInfos && this.mission.planningEntryType === 'STORECHECK'){
            <div class="mission_item_report">
                @if(this.mission.source === 'loga'){
                    <div>
                        {{'PRESENCE_CONFIRMED' | translate}}
                        @if(this.mission.presenceConfirmed){
                            <ion-icon name="thumbs-up-outline" class="green"></ion-icon>
                        }
                        @else{
                            <ion-icon name="thumbs-down-outline" class="orange"></ion-icon>
                        }                
                    </div>
                }
                @if(this.mission.reportable){
                    <div>
                        {{'REPORTING_COMPLETED' | translate}}
                        @if(this.mission.reportingCompleted){
                            <ion-icon name="thumbs-up-outline" class="green"></ion-icon>
                        }
                        @else{
                            <ion-icon name="thumbs-down-outline" class="orange"></ion-icon>
                        } 
                    </div>
                }
                @if(this.mission.source === 'lgg'){                 
                    <div class="mission_item_nb_pictures">
                        <div>
                            <ion-icon name="image-outline"></ion-icon>
                            {{this.mission.nbPictures}}
                        </div>
                    </div>
                }
            </div>
        }
              
        @if(this.displayEvaluation){
            <div class="mission_item_evaluation">
                @if(this.mission.planningEntryType === 'STORECHECK' && this.mission.source === 'loga'){
                    @if(this.mission.evaluationNote !== undefined && this.mission.evaluationNote !== null){
                        <marv-rating [value]="this.mission.evaluationNote" [max]="this.maxRating" size="small"/>
                    }
                    @else if(this.displayBtnAddEvaluation && this.mission.day <= today){
                        <marv-button icon="star" [rounded]="true" (click)="this.evaluateMission($event)" />  
                    }
                }
            </div>
        }
                
        @if(this.displayStatus && this.mission.planningEntryType === 'STORECHECK'){
            <div class="mission_item_status">
                <div class="mission_item_status_label">
                    {{this.mission.status.name | translate}}
                </div>
                <div class="mission_item_status_icon">
                    <ion-icon [name]="this.mission.status.icon" [class]="this.mission.status.color"></ion-icon>
                </div>
            </div>
        }
        
    </div>    
</marv-item>